import { fileURLToPath } from 'node:url';
import { program } from './program.js';
import { showUpdateNudges } from './version-check.js';
import { REFRESH_COMMAND, runVersionRefresh } from './version-refresh.js';
import { healSkillLinkForCommand } from './skill-symlink.js';
import { handleCliError } from './errors.js';
import { initTelemetry, captureException, closeTelemetry } from './telemetry.js';
import pkg from '../package.json' with { type: 'json' };

const SKIP_UPDATE_CHECK = ['--version', '-v', '--help', '-h', 'help', 'update'];
const command = process.argv[2];

async function main(): Promise<void> {
  // Hidden background-refresh dispatch: a detached child re-invokes the CLI with this command to
  // repopulate the version/skill caches off the foreground path. It parses no commands, inits no
  // telemetry, and prints no nudge — it just refreshes the caches and exits.
  if (command === REFRESH_COMMAND) {
    await runVersionRefresh();
    return;
  }

  // Repair Claude Code's `.claude/skills/rekor` symlink on any real command. `npx skills add` skips
  // that link when `.claude/` is absent, so a fresh or wiped repo leaves Claude Code unable to load
  // the rekor skill — and the in-skill nudge can't fix it (it only runs once the skill is loaded).
  // Healing here means the FIRST `rekor` command an agent runs repairs it. Self-guards (no-op unless
  // needed, and resolves the repo root only after its skip check); notice to stderr so `--json`
  // stdout stays pure.
  if (healSkillLinkForCommand(command)) {
    console.error(
      'Linked .claude/skills/rekor → .agents/skills/rekor so Claude Code can load the Rekor skill.',
    );
  }

  await initTelemetry(command, pkg.version);
  await program.parseAsync();
  if (command && !SKIP_UPDATE_CHECK.includes(command)) {
    showUpdateNudges(pkg.version, fileURLToPath(import.meta.url));
  }
}

main()
  .then(() => closeTelemetry())
  .catch(async (err) => {
    handleCliError(err);
    captureException(err);
    await closeTelemetry();
    process.exit(1);
  });
